import { render, staticRenderFns } from "./TextSlide.vue?vue&type=template&id=260528ac&"
import script from "./TextSlide.vue?vue&type=script&lang=ts&"
export * from "./TextSlide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports